import { Link, Stack, Typography, useMediaQuery } from "@mui/material"
import theme from "@skistarab/mui-theme"
import { DOMNode, domToReact, HTMLReactParserOptions } from "html-react-parser"

import useParsedHtml from "@/hooks/useParsedHtml"

type FyiWidgetContentProps = {
  heading: string
  body: string
  link: {
    url: string
    label: string
  }
}

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode.type === "text") {
      return domNode.data
    }
    if (domNode.type === "tag") {
      switch (domNode.tagName) {
        case "a":
          return (
            <Link
              href={domNode.attribs.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {domToReact(domNode.children as DOMNode[], options)}
            </Link>
          )
        case "br":
          return <br />
        default:
          return <>{domToReact(domNode.children as DOMNode[], options)}</>
      }
    }
  },
}

const FyiWidgetContent = ({ heading, body, link }: FyiWidgetContentProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const parsedHeading = useParsedHtml(heading)
  const parsedBody = useParsedHtml(body, options)

  return (
    <Stack alignItems="start" mt={9}>
      <Typography
        component="h2"
        variant={isMobile ? "body2" : "body1"}
        fontWeight={600}
        marginBottom={1}
      >
        {parsedHeading}
      </Typography>
      <Typography variant={isMobile ? "body3" : "body2"} component="p">
        {parsedBody}
      </Typography>
      <Link
        marginTop={1}
        href={link.url}
        fontWeight={600}
        variant="body3"
        target="_blank"
        rel="noopener"
      >
        {link.label}
      </Link>
    </Stack>
  )
}

export default FyiWidgetContent
